import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import { Button, Grid, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ConfigManager } from '../../../../../../application/config/ConfigManager';
import { useI18n } from '../../../../../../application/language/useI18n';
import { observer } from 'mobx-react';
import React from 'react';

import { Colors } from '../../../../../design/color/Colors';
import { ConfirmModal } from '../../../../../design/modal/confirm/ConfirmModal';
import { ApplicationDetailDomain } from '../store/ApplicationDetailDomain';
import { Version } from '../store/ApplicationDetailUI';

export const ApplicationInfoActions = observer(({ domain }: { domain: ApplicationDetailDomain }) => {
  const { translate } = useI18n();
  const classes = useStyles();

  const deleteConfirmation = () => (
    <ConfirmModal
      title={ConfigManager.getConfig()?.localization?.toLowerCase() === 'en' ? 'Delete system?' : 'Удалить систему?'}
      text={
        ConfigManager.getConfig()?.localization?.toLowerCase() === 'en'
          ? `Are you sure you want to remove the system '${domain.ui.application.entity.name}'?`
          : `Вы уверены, что хотите удалить систему '${domain.ui.application.entity.name}'?`
      }
      onCancel={async () => {
        domain.layoutDomain.modalWindow.closeModalWindow();
      }}
      onOk={async () => {
        domain.layoutDomain.modalWindow.closeModalWindow();
        domain.deleteApplication();
      }}
    />
  );

  const onTryToDelete = () => {
    domain.layoutDomain.modalWindow.showModalWindow(deleteConfirmation);
  };

  const generateReportName = ({ reportName }: { reportName: string }) => reportName;
  const reportNameMajor = `_версия ${domain.ui.getVersionWithStatus({ versionType: Version.major })}`;

  return (
    <Grid container className={classes.container}>
      {domain.ui.isCanUpdate.value === true && (
        <Grid item>
          <Button
            variant="outlined"
            onClick={domain.onClickEditApplication}
            color="primary"
            size="large"
            startIcon={<EditIcon />}
            className={classes.actionButton}
          >
            {translate('phrases.edit')}
          </Button>
        </Grid>
      )}
      {domain.ui.isCanDelete.value === true && (
        <Grid item>
          <Button
            variant="contained"
            onClick={onTryToDelete}
            color="error"
            size="large"
            startIcon={<EditIcon />}
            className={classes.actionButton}
          >
            {translate('phrases.delete')}
          </Button>
        </Grid>
      )}
      <Grid item>
        <Button
          variant="contained"
          color="primary"
          size="large"
          startIcon={<SaveIcon />}
          className={classes.actionButton}
          onClick={() => {
            domain.downloadApplicationQuestionnaire({
              format: 'docx',
              reportName: `${generateReportName({ reportName: `Анкета ИБ${reportNameMajor}` })}`,
            });
          }}
        >
          {translate('projectPage.downloadAsProfile')}
        </Button>
      </Grid>
    </Grid>
  );
});

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  actionButton: {
    margin: theme.spacing(2),
    minWidth: theme.spacing(22),
  },
}));
